import { serviceGo } from "@/utils/request";

export interface Costume {
  id?: number
  game_id: number
  role_id: number
  name: string
  description?: string
  image_url: string
  price: number
  is_default?: number
  status?: number
  created_at?: string
  updated_at?: string
}

// 获取角色服装列表（后台）
export async function getCostumeList(gameId: number, roleId: number): Promise<Costume[]> {
  const resp = await serviceGo.get('/api_v2/admin/costume/list', {
    params: { game_id: gameId, role_id: roleId }
  })
  return resp.data.data
}

// 创建服装
export async function createCostume(data: Costume): Promise<Costume> {
  const resp = await serviceGo.post('/api_v2/admin/costume/create', data)
  return resp.data.data
}

// 更新服装
export async function updateCostume(id: number, data: Partial<Costume>): Promise<Costume> {
  const resp = await serviceGo.put('/api_v2/admin/costume/update', data, {
    params: { id }
  })
  return resp.data.data
}

// 删除服装
export async function deleteCostume(id: number): Promise<void> {
  await serviceGo.delete('/api_v2/admin/costume/delete', {
    params: { id }
  })
}
